<template>
  <div>
    <navbar back fixed bg>
      <span slot="title">设置</span>
    </navbar>
    <div class="page-content">
      <div class="input-group">
        <div class="input-list">
          <span class="input-label">手机号码</span>
          <span class="input-num">{{phone}}</span>
        </div>
        <div class="input-list">
          <span class="input-label">实名认证</span>
          <span class="input-num" v-show="status === 0" @click="$router.push('/auth/authentication')">未实名，去认证</span>
          <span class="input-num" v-show="status === 1">已认证&nbsp;&nbsp;&nbsp;&nbsp;{{name}}&nbsp;&nbsp;&nbsp;&nbsp;{{idcard}}</span>
        </div>
      </div>
      <div class="btn-group">
        <button type="button" class="btn-submit" @click="logout">{{btnText}}</button>
      </div>
    </div>
    <spinner :show="loading"></spinner>
  </div>
</template>

<script>
  import Navbar from 'components/navbar/navbar'
  import Spinner from 'components/spinner/spinner'

  export default {
    data () {
      return {
        loading: false,
        btnText: '退出登录',
        status: null,
        name: '',
        phone: '',
        idcard: ''
      }
    },
    components: {
      Navbar,
      Spinner
    },
    created () {
      if (this.$from().isInner) {
        this.btnText = '解除微信绑定'
      }
      this.token = this.$cache.getUserToken()
      this._fetchData()
    },
    methods: {
      _fetchData () {
        let vm = this
//        let time = Date.now()
        this.loading = true
        this.$ajax({
          url: '/center/getUserInfo.jhtml',
          params: {
            uid: vm.token.uid
          },
          done (info) {
            vm.status = info.status
            vm.name = info.name
            vm.phone = info.phone
            vm.idcard = info.idcard
          },
          fail (m) {
            vm.$dialog(m)
          },
          always () {
            vm.loading = false
          }
        })
      },
      logout () {
        if (this.$from().isInner) {
          this.$router.push('/user/unbind')
        } else {
          let vm = this
          this.$dialog({
            type: 'confirm',
            content: '确定要退出吗？',
            onConfirm () {
              vm.$cache.removeUserToken()
              vm.$router.replace('/auth/login')
            }
          })
        }
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import '../../common/css/mixmin'

  .input-group
    margin px2rem(20) 0 px2rem(60)
    padding-left 1em
    background-color #fff
    box-shadow 0 px2rem(10) px2rem(15) rgba(171,185,197, 1)

    .input-list
      position relative
      padding px2rem(23) 0
      width 100%
      & + .input-list:before
        content ''
        position absolute
        top 0
        left 0
        width 100%
        height 0
        border-top 1px dotted #21507f

      .input-label
        margin-right px2rem(20)
        font-size px2rem(28)
        color #21507f

      .input-num
        padding 0 px2rem(5)
        font-size px2rem(24)
        color #fff
        border-radius px2rem(5)
        background-color #129fdd

  .btn-group
    width 100%
    padding 0 px2rem(80)
    .btn-submit
      width 100%
      height px2rem(80)
      font-size px2rem(32)
      color #fff
      letter-spacing px2rem(4)
      border none
      border-radius px2rem(8)
      background-color #60c9c8
      box-shadow 0 0 px2rem(4) rgba(18,119,163, .75)

</style>



// WEBPACK FOOTER //
// settings.vue?49aeee2e